import Repository from './Repository';

export default class WorksheetRepository extends Repository {
    protected basePath = 'worksheets';

    protected messages = {
        preview : this.__('Worksheet preview successfully generated.'),
        update : this.__('Worksheet successfully updated.'),
    }

    protected redirects = {
        store: { name : 'worksheets.edit', params: { worksheet: '$id' } },
    }

    public destroy(id: string, data: object = null): Promise {
        console.error('Destroy method does not exist on WorksheetRepository.');
    }

    public downloadFiles(id: string, params: object = null): Promise {
        if (!this.basePath) {
            console.error('Request: no basePath defined.');

            return;
        }

        return new Promise((resolve, reject) => {
            this.request.get(this.buildPath(this.basePath + '/' + id + '/files', params), { responseType: 'blob' })
                .then((response : any) => {
                    const blob = new Blob([
                        response.data
                    ], { type:'application/zip' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;

                    a.download = 'files.zip';
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => reject(error));
        });
    }

    public downloadSnFiles(id: string, params: object = null): Promise {
        if (!this.basePath) {
            console.error('Request: no basePath defined.');

            return;
        }

        return new Promise((resolve, reject) => {
            this.request.get(this.buildPath(this.basePath + '/sn/' + id + '/files', params), { responseType: 'blob' })
                .then((response : any) => {
                    const blob = new Blob([
                        response.data
                    ], { type:'application/zip' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;

                    a.download = 'files.zip';
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => reject(error));
        });
    }

    public downloadTaskFiles(id: string, params: object = null): Promise {
        if (!this.basePath) {
            console.error('Request: no basePath defined.');

            return;
        }

        return new Promise((resolve, reject) => {
            this.request.get(this.buildPath(this.basePath + '/tasks/' + id + '/files', params), { responseType: 'blob' })
                .then((response : any) => {
                    const blob = new Blob([
                        response.data
                    ], { type:'application/zip' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;

                    a.download = 'files.zip';
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => reject(error));
        });
    }

    public index(params: object = null): Promise {
        console.error('Index method does not exist on WorksheetRepository.');
    }

    public export(params: object = null): Promise {
        console.error('Export method does not exist on WorksheetRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on WorksheetRepository.');
    }

    public preview(id: string, data: object, params: object = null, config: object = null) {
        if (!this.basePath) {
            console.error('Request: no basePath defined.');

            return;
        }

        return new Promise((resolve, reject) => {
            this.request.post(this.buildPath(this.basePath + '/' + id + '/preview', params), data, config)
                .then((response : any) => {
                    this.request.message = this.messages.preview;
                    this.request.status = 200;
                    this.request.title = this.__('Success');

                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    }
}